exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-list i.product-icons {\n  font-size:4rem;\n  margin: 10px auto;\n}\n#data-table-transactions a {\n  color:#666;\n  text-decoration: none;\n}\n", ""]);

// exports
